<template>
  <Modal customClass="modal-readable">
    <template v-slot:header>
      <span class="d-flex flex-row justify-content-between col-12">
        <div></div>
        <h3 v-if="helperNumber == 664" class="fw-bold section-header">Attempts</h3>
        <h3 v-else-if="helperNumber == 182" class="fw-bold section-header">Conspiracies</h3>
        <button class="btn btn-gray float-right" @click="close">
          <i class="fa fa-close"></i>
        </button>
      </span>
    </template>
    <template v-slot:body>
      <div class="d-flex flex-column p-5">
        <h3 class="fs-3 fw-bold">PC {{ helperNumber }}</h3>
        <div v-if="helperNumber == 664">
          <p class="fs-5">
            It appears that you are trying to add an attempted charge. To do so, simply
            search for the statute number of the charged attempt, press the "Add" button,
            and select the "Attempt" option.
          </p>
        </div>
        <div v-else-if="helperNumber == 182">
          <p class="fs-5">
            It appears you are trying to add a conspiracy charge. There are a limited set
            of 182 crimes listed that are directly usable. Alternatively, it is possible to
            set any charge to be added as a conspiracy by simply searching for the statute
            number of the charged conspiracy, clicking the "Add" button, and then selecting
            the "Conspiracy" option.
          </p>
        </div>
      </div>
      
    </template>
    <!-- <template v-slot:footer>spa</template> -->
  </Modal>
</template>
<script>
import Modal from "../../../components/utils/Modal.vue";
export default {
  name: "HelperSearch",
  components: { Modal },
  props: ["helperNumber"],
  methods: {
    close() {
      // console.log("CLOSE");
      this.$emit("closeHelper");
    },
    emitAttempt() {
      this.$emit("Attempt");
    },
    emitConspiracy() {
      this.$emit("Conspiracy");
    },
  },
  mounted() {
    // console.log("MOUNTS");
  },
};
</script>
